module.exports = __webpack_public_path__ + "img/selfassessment.2b2ec52c.svg";